var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.newWork.base.id)?_c('Tour',{attrs:{"newWork":_vm.newWork,"offLine":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }